"use strict";

exports.__esModule = true;
exports.TEMPLATE_CATEGORY_GROUP_ID = exports.TEMPLATE_CATEGORY_ID = exports.FORUM_DATA_CATEGORIES_MANAGER_ID = void 0;
// this refers to forum itself (forumData)
var FORUM_DATA_CATEGORIES_MANAGER_ID = 'FORUM_DATA_CATEGORIES_MANAGER_ID'; // placeholder id for when creating new category

exports.FORUM_DATA_CATEGORIES_MANAGER_ID = FORUM_DATA_CATEGORIES_MANAGER_ID;
var TEMPLATE_CATEGORY_ID = 'TEMPLATE_CATEGORY_ID';
exports.TEMPLATE_CATEGORY_ID = TEMPLATE_CATEGORY_ID;
var TEMPLATE_CATEGORY_GROUP_ID = 'TEMPLATE_CATEGORY_GROUP_ID';
exports.TEMPLATE_CATEGORY_GROUP_ID = TEMPLATE_CATEGORY_GROUP_ID;